module.exports = __webpack_public_path__ + "44ee2f6ab7e5b7f7d33ab9a7f298e5a9.png";